import * as React from "react";
import { SVGProps } from "react";
export function FileTextIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={14}
      height={14}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        clipPath="url(#file-text_svg__a)"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M8.75.75H3.5A1.25 1.25 0 0 0 2.25 2v10a1.25 1.25 0 0 0 1.25 1.25h7A1.25 1.25 0 0 0 11.75 12V4.083L8.75.75Z" />
        <path d="M8.75.75V3.5a.875.875 0 0 0 .875.875h2.125M6 5.25H4.75M9.25 7.25h-4.5M9.25 9.25h-4.5" />
      </g>
      <defs>
        <clipPath id="file-text_svg__a">
          <path fill="#fff" d="M0 0h14v14H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
